import React from 'react';
import { Badge } from './ui/badge';

/**
 * Compact status roll-up strip for a group of machinery cards.
 * Renders one small colored pill per non-zero status so group headers can
 * broadcast fleet health at a glance ("8 Operational · 2 Down").
 */
const STATUS_META = {
  operational: { label: 'Operational', className: 'bg-green-500 hover:bg-green-500 text-white' },
  maintenance_needed: { label: 'Maintenance Needed', className: 'bg-yellow-500 hover:bg-yellow-500 text-white' },
  down: { label: 'Down', className: 'bg-red-500 hover:bg-red-500 text-white' },
  lockout: { label: 'Lockout', className: 'bg-orange-500 hover:bg-orange-500 text-white' },
};

const ORDER = ['down', 'lockout', 'maintenance_needed', 'operational'];

const GroupStatusRollup = ({ machinery, className = '' }) => {
  const counts = machinery.reduce((acc, m) => {
    const key = m.status || 'operational';
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  const pills = ORDER.filter((k) => counts[k]).map((k) => {
    const meta = STATUS_META[k] || { label: k, className: 'bg-slate-500 text-white' };
    return (
      <Badge
        key={k}
        className={`${meta.className} text-[10px] font-semibold px-1.5 py-0.5`}
        data-testid={`rollup-${k}`}
      >
        {counts[k]} {meta.label}
      </Badge>
    );
  });

  if (pills.length === 0) {
    return (
      <span className={`text-xs text-slate-500 ${className}`}>No equipment</span>
    );
  }

  return (
    <div className={`flex flex-wrap items-center gap-1 ${className}`} data-testid="group-status-rollup">
      {pills}
    </div>
  );
};

export default GroupStatusRollup;
